import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { StepModalOption } from '../styled';
import { Breakpoints } from '../../../styled/constants';

export const LeasedOptionWrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  gap: 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex-direction: row;
  }
`;

export const LeasedOption = styled(StepModalOption)`
  width: 100%;
  height: 100%;

  svg {
    fill: ${({ theme }) => theme.colors.text.primary};
    transition: fill 0.3s;
  }

  @media (hover: hover) {
    &:hover {
      border-color: ${({ theme }) => theme.colors.systemColors.blue};

      svg {
        fill: ${({ theme }) => theme.colors.systemColors.blue};
      }

      span {
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;
